<template>
  <modal transition="pop-out" name="new-attributes-group" :width="550" :height="300">
    <div class="h-10 w-full border-b border-gray-200">
      <p class="px-8 py-2 text-gray-700">New Attribute Group</p>
    </div>
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Category Name">
          <p v-if="errors.includes('name')" class="text-red-500 text-xs italic">Please provide a name.</p>
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Status
          </label>
          <el-switch v-model="form.status"></el-switch>
        </div>
        <div class="flex items-center justify-between">
          <el-button @click="submit" type="primary" :loading="creating">Create</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'CreateForm',
  data() {
    return {
      creating: false,
      errors: [],
      form: {
        name: '',
        status: false,
      },
    };
  },
  methods: {
    async submit() {
      this.errors = [];
      // formValidation is a mixin in
      // src/Common/mixins/index.js
      this.errors = this.formValidation(this.form);

      // check for error length
      if (this.errors.length === 0) {
        try {
          this.creating = true;

          await this.$store.dispatch('InventoryModule/Attributes/createAttributeGroup', this.form);
          this.$modal.hide('new-attributes-group');
          this.$notify.success({
            title: 'Success',
            message: 'New Category successfully added',
          });
        } catch (e) {
          console.log(e);
          this.creating = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.creating = false;
      }
    },
  },

};
</script>

<style scoped>

</style>
